import { template as template_40bde3d5f05b49eba2b22fc525a26620 } from "@ember/template-compiler";
import { eq } from 'ember-truth-helpers';
import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default class SiteBillingChannelCoverageInfo extends Component {
    get remainingSessionsCount() {
        return this.args.channelClientInfo?.remainingSessionsCount;
    }
    get channelName() {
        return this.args.channelClientInfo?.globalMonarchChannel?.displayName;
    }
    static{
        template_40bde3d5f05b49eba2b22fc525a26620(`
    <span class="channel-covered">
      {{svgJar "warning-outline" class="icon-warning" aria-hidden="true"}}
      <div class="text">
        {{t
          "billing.coverage.willCover"
          channelName=this.channelName
          count=this.remainingSessionsCount
          appointments=(if
            (eq this.remainingSessionsCount 1)
            (t "billing.coverage.appointment")
            (t "billing.coverage.appointments")
          )
        }}
      </div>
    </span>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
